import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import client from "./apolloClient";
import {
  MuiThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@material-ui/core/styles";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import MuiThemeDark from "./muithemedark";
import MuiThemeLight from "./muithemelight";
import Poll from "./Poll";
import PollResults from "./PollResults";
import { markAnswered, wasAnswered } from "./storage";
import { ApolloProvider } from "@apollo/client";
import {
  DEFCON9,
  DEFCON7,
  DEFCON5,
  DEFCON4,
  DEFCON3,
  DEFCON2,
  DEFCON1,
} from "./debug.json";

const App = (props: { config?: any }) => {
  var pollIdx = props?.config?.pollId || -1;
  const pollId = parseInt(pollIdx);

//   let theme = createTheme();

//   theme = responsiveFontSizes(MuiThemeDark);
  const [answered, setAnswered] = useState<boolean>(wasAnswered(pollId));

  const onAnswer = () => {
    markAnswered(pollId);
    setAnswered(true);
  };

  DEFCON5 && console.log(props.config);

  return (
    <ApolloProvider client={client}>
      <Router>
        <MuiThemeProvider theme={responsiveFontSizes(MuiThemeDark)}>
          <div>
            <Switch>
              <Route path="/">
                {answered ? (
                  <PollResults id={pollId} />
                ) : (
                  <Poll id={pollId} onAnswer={onAnswer} />
                )}
              </Route>
            </Switch>
          </div>
        </MuiThemeProvider>
      </Router>
    </ApolloProvider>
  );
};

export default App;
